/**
 * The user aggregate's storage, over a writer the caller lends. `src/fb` reaches the store, so this
 * context cannot import it without a cycle; until the store is gone the caller supplies the write,
 * and the field names stay here.
 *
 * @param {(userId: string, fields: Object) => Promise<void>} writeAccountFields - merges fields
 *   into the account document
 */
// eslint-disable-next-line import/prefer-default-export
export const userRepository = (writeAccountFields) => ({
  saveTimeZonePreference: (userId, zone) => writeAccountFields(userId, { timeZonePreference: zone }),
});
